module.exports = __webpack_public_path__ + "img/botabib1.c254fa18.png";